import BottomSheet from '@components/BottomSheet'
import { useSwapSlippage } from '@plug-core/state'
import { Box, Input, Stack, Typography } from '@mui/material'
import React, { FC, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  visible?: boolean
  close?: () => void
}

const SwapConfig: FC<Props> = ({ visible, close }) => {
  const { slippage, setSlippage } = useSwapSlippage()
  const [slippageValue, setSlippageValue] = useState<string>(`${slippage}`)
  const [slippageError, setSlippageError] = useState(false)

  const { t } = useTranslation()

  const slippageHigh = useMemo(() => {
    return parseFloat(`${slippage}`) > 4
  }, [slippage])

  const onSlippageChange = (value: string) => {
    setSlippageValue(value)
    const parsed = parseFloat(value)

    setSlippageError(isNaN(parsed))

    if (!isNaN(parsed)) {
      setSlippage(parsed)
    }
  }

  return (
    <BottomSheet visible={visible} onBackdropClick={close}>
      <Stack p={2} spacing={2}>
        <Typography variant="h6" textAlign="center">
          {t('swap.config')}
        </Typography>
        <Stack direction="row" alignItems="center">
          <Stack flex={1}>
            <Typography>{t('swap.slippage')}</Typography>
            {slippageHigh && (
              <Typography fontSize={12} color={(theme) => theme.palette.text.secondary}>
                🚨 {t('swap.errors.slippageTooHigh')}
              </Typography>
            )}
          </Stack>

          <Box
            border={1}
            borderColor={(theme) =>
              slippageError ? theme.palette.rainbow.red : theme.palette.divider
            }
            borderRadius={1}
            px={2}
            width={50}
          >
            <Input
              disableUnderline
              value={slippageValue}
              onChange={(e) => onSlippageChange(e.target.value)}
              autoComplete="off"
              sx={{
                textAlign: 'center',
              }}
              endAdornment={<Typography>%</Typography>}
            />
          </Box>
        </Stack>
      </Stack>
    </BottomSheet>
  )
}

export default SwapConfig
